import { ROUTES } from "../../constants/routes";
import { Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Navbar } from "../../components/navbar/navbar";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";
import { SOLUTIONS } from "../../constants/solutions-data";
import { ICONS } from "../../constants/icons";
import { breadcrumbSchema, webPageSchema } from "../../helpers/structured-data";
import { SITE } from "../../constants/site";

@Component({
  selector: "app-solutions",
  imports: [RouterLink, Breadcrumb, Navbar, Footer],
  templateUrl: "./solutions.html",
  styleUrl: "./solutions.scss"
})
export class Solutions {
  readonly routes = ROUTES;
  private readonly seo = inject(SeoService);
  private readonly sanitizer = inject(DomSanitizer);

  readonly solutions = SOLUTIONS;

  iconFor(name: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(ICONS[name] ?? "");
  }

  ngOnInit(): void {
    this.seo.apply({
      title: "Deceased Verification Solutions by Industry",
      description:
        "How banks, lenders, employers, insurers, government agencies and collections teams use VerifyDeceased to stop deceased identity fraud with nationwide death data.",
      path: "/solutions",
      keywords:
        "deceased verification solutions, death data by industry, deceased fraud prevention, death screening use cases",
      structuredData: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Solutions", path: "/solutions" }
        ]),
        webPageSchema({
          name: "Deceased verification solutions by industry",
          description:
            "Industry specific deceased verification for banks, lenders, employers, insurers, government and collections.",
          path: "/solutions",
          type: "CollectionPage"
        }),
        {
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "VerifyDeceased solutions by industry",
          itemListElement: this.solutions.map((solution, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: solution.name,
            url: `${SITE.domain}/solutions/${solution.slug}`
          }))
        }
      ]
    });
  }
}
